module.exports = __webpack_public_path__ + "static/media/unblock.2cec92f4.svg";